export enum OpenKsyosUrlResult {
    noHandler = 'noHandler',
    notSupportedByBrowser = 'notSupportedByBrowser',
    success = 'success',
    unknown = 'unknown',
}

function createHiddenIframe() {
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    document.body.appendChild(iframe);

    return iframe;
}

function removeHiddenIframe(iframe: HTMLIFrameElement) {
    if (!iframe) {
        return;
    }
    document.body.removeChild(iframe);
}

// based on https://gist.github.com/aaronk6/d801d750f14ac31845e8
export async function openKsyosUrl(url: string): Promise<OpenKsyosUrlResult> {
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    if (isFirefox) {
        const iframe = createHiddenIframe();
        let result;

        if (!iframe.contentWindow) {
            throw new Error(`iframe.contentWindow is null`);
        }

        try {
            iframe.contentWindow.location.href = url;
            result = OpenKsyosUrlResult.success;
        } catch (e) {
            const error = e as { name: string };
            if (error.name === 'NS_ERROR_UNKNOWN_PROTOCOL') {
                result = OpenKsyosUrlResult.noHandler;
            } else {
                throw error;
            }
        }
        removeHiddenIframe(iframe);

        return result;
    } else {
        try {
            window.location.href = url;
        } catch (e) {
            return OpenKsyosUrlResult.notSupportedByBrowser;
        }

        return OpenKsyosUrlResult.success;
    }
}
